const productTypes = [
  { value: 0, name: "车窗膜", key: "WindowFilm" },
  { value: 10, name: "漆面保护膜", key: "ProtectFilm" },
  { value: 20, name: "改色膜", key: "ColorFilm" }
]

const orderStatus = [
  { value: 10, name: "待接单", key: "Booking" },
  { value: 20, name: "待派单", key: "Appointed" },
  { value: 30, name: "改约中", key: "Changing" },
  { value: 40, name: "已派单", key: "Dispatched" },
  { value: 50, name: "商家已完成", key: "Serviced" },
  { value: 70, name: "已结算", key: "Balanced" },
  { value: 80, name: "已拒绝", key: "Rejected" },
  { value: 90, name: "已取消", key: "Canceled" },
]

const tenantStatus = [
  { value: 0, name: "未授权", key: "UnAuthorize" },
  { value: 10, name: "已授权", key: "Authorized" },
  { value: 20, name: "已到期", key: "Expired" },
]

const memberTypes =
  [
    { value: 0, name: "客服接单", key: "Service" },
    { value: 50, name: "店铺主管", key: "Manager" },
    { value: 100, name: "平台管理", key: "TopManager" },
  ]

  const channels =
  [
    { value: 1, name: "点评", key: "DianPing" },
    { value: 2, name: "美团", key: "MeiTuan" },
  ]

export default {
  productTypes,
  tenantStatus,
  memberTypes,
  orderStatus,
  channels
}

